import { animate, query, style, transition, trigger } from '@angular/animations';

export const mobileMenuAnimation = trigger('mobileMenuAnimation', [
  transition(':enter', [
    query('.mobile-menu-container', [
      // start styles
      style({
        opacity: 0.5,
        transform: 'translateX(-100%)',
      }),
      animate('300ms cubic-bezier(0.35, 0, 0.25, 1)',
        // end styles
        style({
          opacity: 1,
          transform: 'translateX(0)',
        }))
    ])
  ]),
  transition(':leave', [
    query('.mobile-menu-container', [
      style({
        opacity: 1,
        transform: 'translateX(0)',
      }),
      animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({
        opacity: 0.5,
        transform: 'translateX(-100%)',
      }))
    ])
  ])
]);
